import React, {useState} from 'react';
import {Box, Card, Button, Typography} from '@mui/material/';
import Grid from '@mui/material/Grid2';
import RequestAdvisoryOpinion from './RequestAdvisoryOpinion';
import FileLegalComplaint from './FileLegalComplaint';

const LegalQuestionList = (): JSX.Element => {

  const [isAdvisoryOpinionDialogOpen, setAdvisoryOpinionDialogOpen] = useState(false);
  const [isLegalComplaintDialogOpen, setLegalComplaintDialogOpen] = useState(false);

  const openAdvisoryOpinionDialog = () => {
    setAdvisoryOpinionDialogOpen(true);
  }

  const closeAdvisoryOpinionDialog = () => {
    setAdvisoryOpinionDialogOpen(false);
  }

  const openLegalComplaintDialog = () => {
    setLegalComplaintDialogOpen(true); 
  }

  const closeLegalComplaintDialog = () => {
    setLegalComplaintDialogOpen(false);
  }

  return (
    <Box marginTop={5} marginBottom={4}>
      <Box marginBottom={4}>
        <Typography
          variant="h6"
          data-aos={'fade-up'}
          align={'center'}
          sx={{
            textTransform: 'uppercase',
          }}
          fontWeight={700}
          gutterBottom
        >
          Legal Questions?
        </Typography>
        <Typography
          variant="h6"
          color={'text.secondary'}
          align={'center'}
          data-aos={'fade-up'}
        >
          OCPF welcomes all inquiries regarding campaign finance activities in Massachusetts. 
          Individuals may call for informal oral advice, or may request a written advisory opinion or 
          may file a confidential request for a review.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid size={{xs:12, md:6}}>
          <Box
            padding={4}
            width={1}
            height={1}
            display={'block'}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              flexDirection={{ xs: 'column', sm: 'row' }}
            >
              <Box>
                <Typography fontWeight={700} variant={'h6'} gutterBottom>
                 How to Request an Advisory Opinion
                </Typography>
                <Typography>If you have questions concerning the specific application of the campaign finance law or OCPF's regulations to activities that have not occurred yet, you may require an Advisory Opinion.</Typography>
              </Box>
              <Box display="flex" marginTop={{ xs: 2, md: 0 }} marginLeft={1}>
                <Button variant="contained" size="large" color={'success'} onClick={openAdvisoryOpinionDialog}>
                  Details
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid size={{xs:12, md:6}}>
          <Box
            padding={4}
            width={1}
            height={1}
            display={'block'}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              flexDirection={{ xs: 'column', sm: 'row' }}
            >
              <Box>
                <Typography fontWeight={700} variant={'h6'} gutterBottom>
                  How to File a Legal Complaint
                </Typography>
                <Typography>If you have concerns regarding possible violations of the campaign finance law or OCPF's regulations, you may file a confidential request for legal review.</Typography>
              </Box>
              <Box display="flex" marginTop={{ xs: 2, md: 0 }} marginLeft={1}>
                <Button variant="contained" color="primary" size="large" onClick={openLegalComplaintDialog}>
                  Details
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <RequestAdvisoryOpinion isDialogOpen={isAdvisoryOpinionDialogOpen} closeDialog={closeAdvisoryOpinionDialog}></RequestAdvisoryOpinion>
      <FileLegalComplaint isDialogOpen={isLegalComplaintDialogOpen} closeDialog={closeLegalComplaintDialog}></FileLegalComplaint>
    </Box>
  );
};

export default LegalQuestionList;
